import * as Sentry from "@sentry/react";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from "src/pages/login/login";
import RenewalHome from "src/pages/home/renewalHome";
import AsList from "src/pages/as/asList";
import AsDetail from "src/pages/as/asDetail";
import AsRegister from "src/pages/as/asRegister";
import EstimateDetail from "src/pages/as/estimateDetail";
import EstimateRegister from "src/pages/as/estimateRegister";
import ReportRegister from "src/pages/as/reportRegister";
import Alarm from "src/pages/alarm/alarm";
import AlarmSetting from "src/pages/alarm/alarmSetting";
import ManageList from "src/pages/manage/manageList";
import GroupAdd from "src/pages/manage/groupAdd";
import GroupEdit from "src/pages/manage/groupEdit";
import ManageGroup from "src/pages/manage/manageGroup";
import Schedule from "src/pages/schedule/schedule";
import Notice from "src/pages/notice/notice";
import Profile from "src/pages/profile/profile";
import Error from "src/pages/error/error";
import ReportDetail from "src/pages/as/reportDetail";
import VisitInfo from "src/pages/as/visitInfo";
import SkuDetail from "src/components/profile/SkuDetail";
import Banner from "src/pages/banner/banner";
import NoticeList from "src/pages/notice/noticeList";
import NoticeRegister from "src/pages/notice/noticeRegister";
import FulfillSelectList from "src/pages/notice/fulfillSelectList";
import NoticeDetail from "src/pages/notice/noticeDetail";
import DashDetail from "src/pages/notice/dashDetail";
import FulfillList from "src/pages/notice/fulfillList";
import FulfillDetail from "src/pages/notice/fulfillDetail";
import RedeemRequest from "src/pages/notice/redeemRequest";
import RedeemSelectImg from "src/pages/notice/redeemSelectImg";
import RedeemDetail from "src/pages/notice/redeemDetail";
import HomeSetting from "src/pages/profile/homeSetting";
import FulfilledDetail from "src/components/profile/FulfilledDetail";
import AsedDetail from "src/components/profile/AsedDetail";
import FulfillRegister from "src/pages/notice/fulfillRegister";
import UserBlock from "../pages/profile/UserBlock";
import Privacy from "../pages/profile/Privacy";

function AnimatedRoutes() {
  const location = useLocation();

  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

  return (
    <SentryRoutes location={location} key={location.pathname}>
      {/* <Routes> */}
      <Route path="/" element={<Login />} />
      <Route path="/home" element={<RenewalHome />} />
      <Route path="/notice" element={<Notice />} />
      <Route path="/as-list/" element={<AsList />}>
        <Route path=":progress" element={<AsList />} />
      </Route>
      <Route path="/as-detail/:as_idx" element={<AsDetail />} />
      <Route path="/as-register/" element={<AsRegister />}>
        <Route path=":as_idx" element={<AsRegister />} />
      </Route>
      <Route path="/estimate-detail/:as_idx" element={<EstimateDetail />} />
      <Route path="/estimate-register/:as_idx" element={<EstimateRegister />} />
      <Route path="/report-register/:as_idx" element={<ReportRegister />} />
      <Route path="/report-detail/:as_idx" element={<ReportDetail />} />
      <Route path="/visitInfo/:as_idx" element={<VisitInfo />} />
      <Route path="/alarm" element={<Alarm />} />
      <Route path="/alarm-setting" element={<AlarmSetting />} />
      <Route path="/manage-list" element={<ManageList />} />
      <Route path="/manage-group/:group_part_idx" element={<ManageGroup />} />
      <Route path="/group-add" element={<GroupAdd />}>
        <Route path=":group_part_idx" element={<GroupAdd />} />
      </Route>
      <Route path="/group-edit" element={<GroupEdit />}>
        <Route path=":group_part_idx" element={<GroupEdit />} />
      </Route>
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/profile/" element={<Profile />}>
        <Route path=":user_id" element={<Profile />} />
      </Route>
      <Route path="/sku-detail/:user_id" element={<SkuDetail />} />
      <Route path="/error" element={<Error />} />
      <Route path="/banner" element={<Banner />} />

      {/* 2차 공지 */}
      <Route path="/notice-list/" element={<NoticeList />}>
        <Route path=":notice_idx" element={<NoticeList />} />
      </Route>
      <Route path="/notice-register/" element={<NoticeRegister />}>
        <Route path=":notice_idx" element={<NoticeRegister />} />
      </Route>
      <Route path="/fulfill-select" element={<FulfillSelectList />} />
      <Route path="/notice-detail/:notice_idx" element={<NoticeDetail />} />
      <Route path="/dash-detail/:notice_idx" element={<DashDetail />} />
      <Route path="/fulfill-list/:notice_idx" element={<FulfillList />} />
      <Route path="/fulfill-register/:fulfill_id" element={<FulfillRegister />} />
      <Route path="/fulfill-detail/:execute_idx" element={<FulfillDetail />} />
      <Route path="/redeem-select" element={<RedeemSelectImg />} />
      <Route path="/redeem-request" element={<RedeemRequest />} />
      <Route path="/redeem-detail/:img_idx" element={<RedeemDetail />} />
      <Route path="/home-setting/" element={<HomeSetting />}>
        <Route path=":user_id" element={<HomeSetting />} />
      </Route>
      <Route path="/fulfilled-detail/:user_id" element={<FulfilledDetail />} />
      <Route path="/ased-detail/:user_id" element={<AsedDetail />} />
      <Route path="/block-user" element={<UserBlock />} />
      <Route path="/privacy" element={<Privacy />} />
      {/* </Routes> */}
      <Route path="*" element={<Error />} />
    </SentryRoutes>
  );
}

export default AnimatedRoutes;
